import classNames from 'classnames';

import { HeaderStepperOptions } from '@Components/MainForm/types';
import styles from './header-stepper.module.css';

interface HeaderStepperProps {
  options: HeaderStepperOptions;
}

const HeaderStepper: React.FC<HeaderStepperProps> = ({ options }) => {
  const { items, counter, onClick, allowAll } = options;

  const defineClassStatus = (
    index: number,
    undisabelAll = false
  ): string | null => {
    if (counter < index && !undisabelAll) {
      return styles.disabled;
    }

    return null;
  };

  const handleClick = (status: string | null, step: number): void => {
    const isDisabled = status && status.includes('disabled');
    if (!isDisabled) {
      onClick(step);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.stepContainer}>
          {items.map((name, index) => {
            const firstItem = index === 0;
            const lastItem = index === items.length - 1;
            return (
              <div className={styles.wrapperItem} key={name}>
                <div
                  className={classNames(
                    styles.item,
                    counter === index
                      ? styles.active
                      : defineClassStatus(index, allowAll),
                    firstItem ? styles.firstItem : null,
                    lastItem ? styles.lastItem : null
                  )}
                  onClick={() =>
                    handleClick(defineClassStatus(index, allowAll), index)
                  }
                >
                  <div
                    className={classNames(
                      styles.circle,
                      counter === index
                        ? styles.active
                        : defineClassStatus(index)
                    )}
                  />
                  <div
                    className={classNames(
                      styles.textContainer,
                      firstItem ? styles.firstItem : null,
                      lastItem ? styles.lastItem : null
                    )}
                  >
                    <span className={styles.index}>{index + 1}.</span>
                    <span className={styles.text}>{name}</span>
                  </div>
                </div>
                {index < items.length - 1 && <div className={styles.line} />}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HeaderStepper;
